import styled from 'styled-components'

export const CartPicker = styled.div`
  [class*='Period']:has([class^='Portal']:not(:empty)), [class^='Portal']:not(:empty) {
    max-height: 100%;
    height: 100%;

    overflow-y: auto;
  }

  [class^='Period'] {
    overflow-y: auto;
  }

  @media screen and (max-width: 576px) {
    .DayPicker-NavBar {
      display: none;
    }
  }

  @media screen and (min-width: 576px) {
    .DayPicker {
      min-height: 350px;
    }
  }
`
